export default __webpack_public_path__ + "static/media/dev-no-apps.8db7582a.svg";